export enum AuthorisationEnum {
  EDIT = 'EDIT',
  COMMENT = 'COMMENT',
  WATCH = 'WATCH',

}
